const basePath = process.env.REACT_APP_BASE_PATH || ''

export function createIndexRoute(route, storeCode = '*'){
  return `${basePath}/`
}

export function createStoreRoute(route, storeCode = '*'){
  if(route === ''){
    return `${basePath}/s/${storeCode}`
  }
  return `${basePath}/s/${storeCode}/${route}`
}
